import { Switch } from '@material-ui/core';

const GuardCardItem = ({
  text,
  switchChecked,
  classes,
  handleSwitchChange,
}) => {
  return (
    <div className={classes.guardCardItemContainer}>
      <span className={classes.guardCardItemText}>{text}</span>
      <Switch
        className={classes.guardSwitch}
        checked={switchChecked}
        onChange={(e) => handleSwitchChange(e.target.checked)}
        inputProps={{ 'aria-label': 'controlled' }}
      />
    </div>
  );
};
export default GuardCardItem;
